import { render, staticRenderFns } from "./TopTab.vue?vue&type=template&id=0a182aae&scoped=true&"
import script from "./TopTab.vue?vue&type=script&lang=js&"
export * from "./TopTab.vue?vue&type=script&lang=js&"
import style0 from "./TopTab.vue?vue&type=style&index=0&id=0a182aae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a182aae",
  null
  
)

export default component.exports